import React from 'react';
import { ExternalLink } from 'lucide-react';
import { normalizeUrl } from '../../utils/textProcessing.js';
const CtaUrlBlock = ({ entry }) => {
  const url = normalizeUrl(entry.params?.ctaUrl);
  const color = entry.modeConfig?.color || '#6366F1';
  if (!url) return null;
  return (
    <div style={{ marginTop: '14px' }}>
      <a href={url} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '10px 20px', background: `${color}20`, border: `1px solid ${color}50`, borderRadius: '8px', color, fontSize: '13px', fontWeight: 500, textDecoration: 'none' }}>
        <ExternalLink size={13} /> {url}
      </a>
    </div>
  );
};
export default CtaUrlBlock;
